// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PCUser\ApiPCUser.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Image, ImageData, ImageOptions } from 'data/models/Image';
import { LloydVesselServiceQuery, LloydVesselServiceQueryData, LloydVesselServiceQueryOptions } from 'data/models/LloydVesselServiceQuery';
import { MarineTrafficVesselServiceQuery, MarineTrafficVesselServiceQueryData, MarineTrafficVesselServiceQueryOptions } from 'data/models/MarineTrafficVesselServiceQuery';
import { Notification, NotificationData, NotificationOptions } from 'data/models/Notification';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { PCUserPortCallEditor, PCUserPortCallEditorData, PCUserPortCallEditorOptions } from 'data/models/PCUserPortCallEditor';
import { PhoneNumber, PhoneNumberData, PhoneNumberOptions } from 'data/models/PhoneNumber';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { PSixVesselServiceQuery, PSixVesselServiceQueryData, PSixVesselServiceQueryOptions } from 'data/models/PSixVesselServiceQuery';
import { Share, ShareData, ShareOptions } from 'data/models/Share';
import { TaggedCommentUser, TaggedCommentUserData, TaggedCommentUserOptions } from 'data/models/TaggedCommentUser';
import { TopicCard, TopicCardData, TopicCardOptions } from 'data/models/TopicCard';
import { TopicCardTemplateUserAssignment, TopicCardTemplateUserAssignmentData, TopicCardTemplateUserAssignmentOptions } from 'data/models/TopicCardTemplateUserAssignment';
import { TopicCardUserAssignment, TopicCardUserAssignmentData, TopicCardUserAssignmentOptions } from 'data/models/TopicCardUserAssignment';
import { UITheme, UIThemeData, UIThemeOptions } from 'data/models/UITheme';
import { User, UserData, UserOptions } from 'data/models/User';

// PCUserData is the class that PCUser serializes to/from
export interface PCUserData {
    Id : number;
    Url : string | null;
	
    AnsweredTopicCards : TopicCardData[] | null;
    CommentsTaggedIn : TaggedCommentUserData[] | null;
    LloydVesselServiceQueries : LloydVesselServiceQueryData[] | null;
    MarineTrafficVesselServiceQueries : MarineTrafficVesselServiceQueryData[] | null;
    Notifications : NotificationData[] | null;
    Organization : OrganizationData | null;
    OrganizationId : number;
    PhoneNumbers : PhoneNumberData[] | null;
    PhoneNumbersUrl : string | null;
    PortCallEditors : PCUserPortCallEditorData[] | null;
    PortCalls : PortCallData[] | null;
    PortCallsAsAgent : PortCallData[] | null;
    PortCallsAsRequestor : PortCallData[] | null;
    PSixVesselServiceQueries : PSixVesselServiceQueryData[] | null;
    Shares : ShareData[] | null;
    TopicCards : TopicCardUserAssignmentData[] | null;
    TopicCardTemplates : TopicCardTemplateUserAssignmentData[] | null;
    UITheme : UIThemeData | null;
    UIThemeId : number | null;
    User : UserData | null;
	
    Active : boolean;
    FirstName : string;
    Guid : /* GUID */ string;
    Image : ImageData;
    JobDescription : string | null;
    LandingPage : string | null;
    LastName : string;
    NotificationEmail : string | null;
    PortCallEditorsUrlBase : string | null;
    PrivateContactInfo : boolean;
}

// PCUserOptions is the class which may be passed to the PCUser constructor to define optional initial data values
export interface PCUserOptions {
    Id : number;
    Url? : string | null;
	
    AnsweredTopicCards? : TopicCardOptions[] | null;
    CommentsTaggedIn? : TaggedCommentUserOptions[] | null;
    LloydVesselServiceQueries? : LloydVesselServiceQueryOptions[] | null;
    MarineTrafficVesselServiceQueries? : MarineTrafficVesselServiceQueryOptions[] | null;
    Notifications? : NotificationOptions[] | null;
    Organization? : OrganizationOptions | null;
    OrganizationId? : number;
    PhoneNumbers? : PhoneNumberOptions[] | null;
    PhoneNumbersUrl? : string | null;
    PortCallEditors? : PCUserPortCallEditorOptions[] | null;
    PortCalls? : PortCallOptions[] | null;
    PortCallsAsAgent? : PortCallOptions[] | null;
    PortCallsAsRequestor? : PortCallOptions[] | null;
    PSixVesselServiceQueries? : PSixVesselServiceQueryOptions[] | null;
    Shares? : ShareOptions[] | null;
    TopicCards? : TopicCardUserAssignmentOptions[] | null;
    TopicCardTemplates? : TopicCardTemplateUserAssignmentOptions[] | null;
    UITheme? : UIThemeOptions | null;
    UIThemeId? : number | null;
    User? : UserOptions | null;
	
    Active? : boolean;
    FirstName? : string;
    Guid? : /* GUID */ string;
    Image? : ImageOptions;
    JobDescription? : string | null;
    LandingPage? : string | null;
    LastName? : string;
    NotificationEmail? : string | null;
    PortCallEditorsUrlBase? : string | null;
    PrivateContactInfo? : boolean;
}

export class PCUser {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public AnsweredTopicCards : SDataArray<TopicCard>;
    public CommentsTaggedIn : SDataArray<TaggedCommentUser>;
    public LloydVesselServiceQueries : SDataArray<LloydVesselServiceQuery>;
    public MarineTrafficVesselServiceQueries : SDataArray<MarineTrafficVesselServiceQuery>;
    public Notifications : SDataArray<Notification>;
    public Organization : DataSignal<Organization | null>;
    public OrganizationId : DataSignal<number>;
    public PhoneNumbers : SDataArray<PhoneNumber>;
    public PhoneNumbersUrl : DataSignal<string | null>;
    public PortCallEditors : SDataArray<PCUserPortCallEditor>;
    public PortCalls : SDataArray<PortCall>;
    public PortCallsAsAgent : SDataArray<PortCall>;
    public PortCallsAsRequestor : SDataArray<PortCall>;
    public PSixVesselServiceQueries : SDataArray<PSixVesselServiceQuery>;
    public Shares : SDataArray<Share>;
    public TopicCards : SDataArray<TopicCardUserAssignment>;
    public TopicCardTemplates : SDataArray<TopicCardTemplateUserAssignment>;
    public UITheme : DataSignal<UITheme | null>;
    public UIThemeId : DataSignal<number | null>;
    public User : DataSignal<User | null>;
	
    public Active : DataSignal<boolean>;
    public FirstName : DataSignal<string>;
    public Guid : DataSignal<string>;
    public Image : Image;
    public JobDescription : DataSignal<string | null>;
    public LandingPage : DataSignal<string | null>;
    public LastName : DataSignal<string>;
    public NotificationEmail : DataSignal<string | null>;
    public PortCallEditorsUrlBase : DataSignal<string | null>;
    public PrivateContactInfo : DataSignal<boolean>;

    constructor();
    constructor(data : PCUserOptions);
    constructor(data: PCUserOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.AnsweredTopicCards = SArray<TopicCard>([]);
        this.CommentsTaggedIn = SArray<TaggedCommentUser>([]);
        this.LloydVesselServiceQueries = SArray<LloydVesselServiceQuery>([]);
        this.MarineTrafficVesselServiceQueries = SArray<MarineTrafficVesselServiceQuery>([]);
        this.Notifications = SArray<Notification>([]);
        this.Organization = S.value<Organization | null>(null);
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.PhoneNumbers = SArray<PhoneNumber>([]);
        this.PhoneNumbersUrl = jsonableObservable(S.value<string | null>(data && data.PhoneNumbersUrl !== undefined ? data.PhoneNumbersUrl : null));
        this.PortCallEditors = SArray<PCUserPortCallEditor>([]);
        this.PortCalls = SArray<PortCall>([]);
        this.PortCallsAsAgent = SArray<PortCall>([]);
        this.PortCallsAsRequestor = SArray<PortCall>([]);
        this.PSixVesselServiceQueries = SArray<PSixVesselServiceQuery>([]);
        this.Shares = SArray<Share>([]);
        this.TopicCards = SArray<TopicCardUserAssignment>([]);
        this.TopicCardTemplates = SArray<TopicCardTemplateUserAssignment>([]);
        this.UITheme = S.value<UITheme | null>(null);
        this.UIThemeId = jsonableObservable(S.value<number | null>(data && data.UIThemeId !== undefined ? data.UIThemeId : null));
        this.User = S.value<User | null>(null);
	    
        this.Active = jsonableObservable(S.value<boolean>(data && data.Active !== undefined ? data.Active : false));
        this.FirstName = jsonableObservable(S.value<string>(data && data.FirstName !== undefined ? data.FirstName : ''));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Image = data && data.Image !== undefined ? new Image(data.Image) : new Image();
        this.JobDescription = jsonableObservable(S.value<string | null>(data && data.JobDescription !== undefined ? data.JobDescription : null));
        this.LandingPage = jsonableObservable(S.value<string | null>(data && data.LandingPage !== undefined ? data.LandingPage : null));
        this.LastName = jsonableObservable(S.value<string>(data && data.LastName !== undefined ? data.LastName : ''));
        this.NotificationEmail = jsonableObservable(S.value<string | null>(data && data.NotificationEmail !== undefined ? data.NotificationEmail : null));
        this.PortCallEditorsUrlBase = jsonableObservable(S.value<string | null>(data && data.PortCallEditorsUrlBase !== undefined ? data.PortCallEditorsUrlBase : null));
        this.PrivateContactInfo = jsonableObservable(S.value<boolean>(data && data.PrivateContactInfo !== undefined ? data.PrivateContactInfo : false));
    }

    static key(obj : PCUser) {
        return obj.Id();
    }
    
    static dataKey(obj : PCUserOptions) {
        return obj.Id;
    }

    static update(obj : PCUser, data : PCUserOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
            if (data.PhoneNumbersUrl !== undefined) obj.PhoneNumbersUrl(data.PhoneNumbersUrl);
            if (data.UIThemeId !== undefined) obj.UIThemeId(data.UIThemeId);
	        
            if (data.Active !== undefined) obj.Active(data.Active);
            if (data.FirstName !== undefined) obj.FirstName(data.FirstName);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.Image !== undefined) Image.update(obj.Image, data.Image);
            if (data.JobDescription !== undefined) obj.JobDescription(data.JobDescription);
            if (data.LandingPage !== undefined) obj.LandingPage(data.LandingPage);
            if (data.LastName !== undefined) obj.LastName(data.LastName);
            if (data.NotificationEmail !== undefined) obj.NotificationEmail(data.NotificationEmail);
            if (data.PortCallEditorsUrlBase !== undefined) obj.PortCallEditorsUrlBase(data.PortCallEditorsUrlBase);
            if (data.PrivateContactInfo !== undefined) obj.PrivateContactInfo(data.PrivateContactInfo);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PCUser.ts